import React from 'react';
import { DrawType } from '@apply/constants';
import { ReactElement } from 'react';
import { DrawAutomaticTotalItems } from './DrawAutomaticTotalItems';
import { DrawManualInspectionTotalItems } from './DrawManualInspectionTotalItems';
import { DrawManualTotalItems } from './DrawManualTotalItems';
import { DrawAutomaticBorrowerTotalItems } from './DrawAutomaticBorrowerTotalItems';
import { DrawManualBorrowerDrawItems } from './DrawManualBorrowerDrawItems';

interface IDrawTotalItemsProps {
    drawId: number;
    drawNumber: number;
    drawType: DrawType;
    drawFinalized: boolean;
    hasResubmitted: boolean;
    needsBorrowerSignature: boolean;
    isInspectionRequireFirst: boolean;
    toggleArray: boolean[];
    isAdmin: boolean;
}

export const DrawTotalItems = ({
    drawId,
    drawNumber,
    drawType,
    drawFinalized,
    hasResubmitted,
    needsBorrowerSignature,
    isInspectionRequireFirst,
    toggleArray,
    isAdmin,
}: IDrawTotalItemsProps): ReactElement[][] => {
    const AdminTotalItem = () => {
        switch (drawType) {
            case DrawType.Automatic:
                return [
                    DrawAutomaticTotalItems({
                        drawId,
                        drawNumber,
                        drawFinalized,
                        toggleArray,
                    }),
                ];
            case DrawType.Manual:
                if (isInspectionRequireFirst) {
                    return [
                        DrawManualInspectionTotalItems({
                            drawId,
                            drawNumber,
                            drawFinalized,
                            toggleArray,
                        }),
                    ];
                } else {
                    return [
                        DrawManualTotalItems({
                            drawId,
                            drawNumber,
                            drawFinalized,
                            toggleArray,
                        }),
                    ];
                }
            default:
                return [[<div>Error loading draw columns</div>]];
        }
    };

    const BorrowerTotalItem = () => {
        switch (drawType) {
            case DrawType.Automatic:
                return [
                    DrawAutomaticBorrowerTotalItems({
                        drawId,
                        drawNumber,
                        drawFinalized,
                    }),
                ];
            case DrawType.Manual:
                return [
                    DrawManualBorrowerDrawItems({
                        drawId,
                        drawNumber,
                        drawFinalized,
                        needsBorrowerSignature,
                        hasResubmitted,
                    }),
                ];
            default:
                return [[<div>Error loading draw columns</div>]];
        }
    };

    if (isAdmin) {
        return AdminTotalItem();
    } else {
        return BorrowerTotalItem();
    }
};
